import { CellContext } from "@tanstack/react-table"

import { UITypes } from "types"

import { CustomerEmail } from "../CustomerEmail"

interface Props {
  cell: CellContext<UITypes.TableBodyRow, UITypes.TableBodyCell>
}

export const MainRowCustomerEmail = (props: Props) => {
  if (props.cell.row.parentId) return null
  return <CustomerEmail cell={props.cell} />
}
